































import { Vue, Component } from 'vue-property-decorator';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import LineOfficialConnectionDialog from '../../components/line/LineOfficialConnectionDialog.vue';
import { URIs } from '../../../src_server/common/URIs';
import StudentPaymentDialog from './StudentPaymentDialog.vue';
import { Session } from '../../utils/Session';

@Component({
  components: { CommonDialog, LineOfficialConnectionDialog, StudentPaymentDialog },
})
export default class StudentDocumentListDialog extends Vue {
  private redirectPath = URIs.LINE_NOTIFY_CONNECT_STU_DONE.path;

  get isCO() {
    return Session.isCircleOBuilding();
  }
  public async show() {
    (this.$refs['document_list'] as CommonDialog).show();
  }

  public close() {
    (this.$refs['document_list'] as CommonDialog).hide();
  }
  async showOffical() {
    await (this.$refs['LineOfficialConnectionDialog'] as LineOfficialConnectionDialog).show();
  }

  showFirstStep() {
    window.open('/pdf/first_step.pdf', '_blank');
  }
  showFAQ() {
    window.open('/pdf/faq_stu.pdf', '_blank');
  }
  showAddAccount() {
    window.open('/pdf/family_account.pdf', '_blank');
  }
  cancelPolicy() {
    window.open('https://docs.google.com/document/d/1vzljs0O33vZ_7EowVuEdkT4Dq4pWY9Vm8HIVq37Z-jo/edit?usp=sharing', '_blank');
  }
  rule() {
    window.open('https://docs.google.com/document/d/1vGhrl6ejQQmEZYHHMWLYK7mOIO5knpvSpvyaiRnPLAE/edit', '_blank');
  }

  async payment() {
    console.log('StudentPaymentDialog');
    await (this.$refs['StudentPaymentDialog'] as StudentPaymentDialog).show(Session.getSessionUserId(), Session.getSessionBuildingId());
  }
}
